import React, { useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

type BroadcastChannel = 'APP' | 'PUSH' | 'EMAIL' | 'WHATSAPP' | 'SMS';

export function ChatBroadcastCenter() {
  const [form, setForm] = useState({
    titulo: '',
    mensagem: '',
    publico: 'familias',
    canal: 'APP' as BroadcastChannel,
  });
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await api.post('/chat-interno/broadcasts', form);
      setForm({ titulo: '', mensagem: '', publico: 'familias', canal: 'APP' });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ac-chat-v8-panel">
      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Comunicado segmentado</h3>
        <div style={{ display: 'grid', gap: 9, marginTop: 12 }}>
          <input className="ac-chat-v8-input" value={form.titulo} onChange={(e) => setForm((p) => ({ ...p, titulo: e.target.value }))} placeholder="Título do comunicado" />
          <select className="ac-chat-v8-select" value={form.publico} onChange={(e) => setForm((p) => ({ ...p, publico: e.target.value }))}>
            <option value="familias">Famílias</option>
            <option value="escolas">Escolas</option>
            <option value="professores">Professores</option>
            <option value="municipio">Município</option>
            <option value="todos">Todos</option>
          </select>
          <select className="ac-chat-v8-select" value={form.canal} onChange={(e) => setForm((p) => ({ ...p, canal: e.target.value as BroadcastChannel }))}>
            <option value="APP">App</option>
            <option value="PUSH">Push</option>
            <option value="EMAIL">E-mail</option>
            <option value="WHATSAPP">WhatsApp oficial</option>
            <option value="SMS">SMS</option>
          </select>
          <textarea className="ac-chat-v8-textarea" value={form.mensagem} onChange={(e) => setForm((p) => ({ ...p, mensagem: e.target.value }))} placeholder="Mensagem do comunicado" />
          <button className="ac-chat-action-btn is-success" disabled={sending} onClick={send}>{sending ? 'Enviando...' : 'Enviar comunicado'}</button>
        </div>
      </div>
    </div>
  );
}
